import React from 'react'
import styled from 'styled-components'
import { colors } from '../../constants/style'

const CategoryImg = styled.img`
  width: 24px;
  height: 24px;
  display: block;
  margin-bottom: 0;
`

const CategoryLabel = styled.div`
  display: none;
  position: absolute;
  left: 2rem;
  width: 8rem;
  font-size: 12px;
  color: ${colors.gray};
  text-align: left;
  line-height: 15px;

  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

const Container = styled.div`
  position: relative;
  margin: 0 0 0 24px;
  &:hover ${CategoryLabel} {
    display: -webkit-box;
  }
`

const CategoryBall = ({ src, alt }) => {
  return src && alt ? (
    <Container>
      <CategoryLabel>{alt}</CategoryLabel>
      <CategoryImg src={src} alt={alt} />
    </Container>
  ) : null
}

export default CategoryBall



// WEBPACK FOOTER //
// ./src/components/CategoryBall/index.js